var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3 -3 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.54 8.21        C46.33 8.21, 54.30 25.66, 56.27 27.63        C58.24 29.60, 75.69 37.57, 75.69 40.36        C75.69 43.15, 58.24 51.12, 56.27 53.09        C54.30 55.06, 46.33 72.51, 43.54 72.51        C40.75 72.51, 32.78 55.06, 30.81 53.09        C28.84 51.12, 11.39 43.15, 11.39 40.36        C11.39 37.57, 28.84 29.60, 30.81 27.63        C32.78 25.66, 40.75 8.21, 43.54 8.21        Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar4);
export default __webpack_public_path__ + "static/media/star4.03beaadd45a9141d6a9184634122a7ba.svg";
export { ForwardRef as ReactComponent };